import { defaultPercentField, defaultField } from "helpers/row-logic-helper";
import { get } from "lodash";

export const companyOwnersMapNestedRows = loan => {
  const items = defaultField(loan, "companyOwners");

  return items.reduce((accum, item) => {
    const percentAllocated = defaultPercentField(item, "ownershipPercentage", 1);
    const isExternalEquitySource = get(item, "isExternalEquitySource");

    accum.push({
      name: defaultField(item, "company.name"),
      percentAllocated: percentAllocated ? `${percentAllocated}% Allocated` : undefined,
      isExternalEquitySource: isExternalEquitySource ? "External Equity" : "Internal Equity"
    });

    return accum;
  }, []);
};
